// extracted by mini-css-extract-plugin
export var newContentVideoModal = "TwinCanHelp-module--newContentVideoModal--5DRYS";
export var newVideoModalClose = "TwinCanHelp-module--newVideoModalClose--OF0jj";
export var twinCanHelp_heading = "TwinCanHelp-module--twinCanHelp_heading--qiY0K";
export var twinCanHelp_image = "TwinCanHelp-module--twinCanHelp_image--GjmuR";
export var twinCanHelp_image_play = "TwinCanHelp-module--twinCanHelp_image_play--5wteZ";
export var twinCanHelp_section = "TwinCanHelp-module--twinCanHelp_section--5G5jz";